<template >
  <div>
    <div
      class="card mb-4"
      v-for="(topic, index) in topics"
      v-bind:key="topic.id"
      v-if="topics != null && topics.length > 0"
    >
      <div class="card-body">
        <div class="row mb-2">
          <div class="col" style="border-bottom: 1px solid #4285f4">
            <p class="m-0 mb-3 topicTitle">
              <span class="font-weight-bold">Сэдэв {{ index + 1 }}. </span
              >{{ topic.name }}
            </p>
          </div>
        </div>
        <p v-if="topic.description != null && topic.description != ''">
          {{ topic.description }}
        </p>
        <div
          v-if="
            topic.tags != null &&
            topic.tags != undefined &&
            topic.tags.length > 0
          "
        >
          Түлхүүр үгс:
          <span
            class="badge badge-pill badge-success mr-2"
            v-for="(tag, ti) in topic.tags"
          >
            {{ tag }}
            <!-- <i class="fas fa-times ml-2" style="cursor:pointer" @click="removeTag(tag, ti)"></i> -->
          </span>
        </div>
        <div v-if="display == 0">
          <div class="row mt-4">
            <!-- v-if="(item.published&&item.published!=null&&item.published!=undefined)||topic.published" -->
            <div
              class="col-md-4 mb-3"
              v-for="(item, index) in topic.details"
              v-bind:key="item.id"
            >
              <div
                class="card mycard"
                style="cursor: pointer"
                @click="goContentDetail(topic, item)"
              >
                <div class="card-body">
                  <div class="row justify-content-between">
                    <div class="col-8">
                      <h6 class="card-title topicItemTitle">
                        {{ index + 1 }}. {{ item.name }}
                      </h6>
                    </div>
                    <div class="col-4 text-right">
                      <span
                        v-if="item.type == 'lecture'"
                        class="badge badge-warning"
                        style="color: black"
                        >{{ getType(item.type) }}</span
                      >
                      <span
                        v-else-if="item.type == 'video'"
                        class="badge badge-warning"
                        style="color: black"
                        >{{ getType(item.type) }}</span
                      >
                      <span
                        v-else-if="item.type == 'seminar'"
                        class="badge badge-warning"
                        style="color: black"
                        >{{ getType(item.type) }}</span
                      >

                      <span
                        v-else-if="item.type == 'coursework'"
                        class="badge badge-info"
                        style="color: black"
                        >{{ getType(item.type) }}</span
                      >
                      <span
                        v-else-if="item.type == 'assignment'"
                        class="badge badge-info"
                        style="color: black"
                        >{{ getType(item.type) }}</span
                      >

                      <span
                        v-else-if="item.type == 'test'"
                        class="badge badge-danger"
                        style="color: black"
                        >{{ getType(item.type) }}</span
                      >
                      <span
                        v-else-if="item.type == 'exam'"
                        class="badge badge-danger"
                        style="color: black"
                        >{{ getType(item.type) }}</span
                      >
                    </div>
                  </div>
                  <div class="card-text" v-if="item.duration != null">
                    <span style="font-size: 10pt" class="text-danger"
                      >{{ item.duration }} минут</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list-group" v-else>
          <div
            v-for="(item, index) in topic.details"
            v-bind:key="item.id"
            class="list-group-item list-group-item-action flex-column align-items-start"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">{{ index + 1 }}. {{ item.name }}</h5>
              <div>
                <small v-if="item.type != null && item.type != undefined">
                  {{ item.type }}
                </small>
              </div>
            </div>
            <p class="mb-1">{{ item.description }}</p>
            <p class="mb-1" v-if="item.duration != null">
              Үргэлжлэх хугацаа: {{ item.duration }} минут
            </p>
            <div class="my-3"></div>
            <p class="mb-1" v-if="item.startDay != null">
              Эхлэх: {{ item.startDay | formatDate }}
            </p>
            <p class="mb-1" v-if="item.endDay != null">
              Дуусах: {{ item.endDay | formatDate }}
            </p>

            <ul>
              <li style="margin-bottom: 18px" v-if="item.videoUrl != null">
                <br />

                <iframe
                  width="560"
                  height="315"
                  v-if="
                    item.videoUrl != null &&
                    item.videoUrl != '' &&
                    item.videoUrl.toLowerCase().indexOf('youtube') != -1
                  "
                  v-bind:src="getYoutubeIframe(item.videoUrl)"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import firebase from "firebase";

export default {
  name: "PublicTopics",

  data() {
    return {
      display: 0,
      selectedTopic: null,
      content: {
        name: null,
        description: null,
        videoUrl: null,
        published: false,
        startDay: null,
        endDay: null,
        code: null,
        duration: null,
        shortname: null,
      },
      selectedType: null,
      selectedTopic: null,
    };
  },

  methods: {
    goContentDetail(topic, content) {
      console.log(topic, content);
      if (topic != null && content != null) {
        if (content.type == "exam" || content.type == "test") {
          this.$router.push({
            name: "ExamPage",
            params: {
              schoolId: this.schoolId,
              lessonId: this.lessonId,
              topicId: topic.id,
              contentId: content.id,
            },
          });
        }
        // this.$router.push({ name: 'IQuestions', params: {schoolId: this.schoolId, lessonId: this.lessonId, topicId: topic.id, detailId: content.id} });
        else
          this.$router.push({
            name: "StudentContentDetail",
            params: {
              schoolId: this.schoolId,
              lessonId: this.lessonId,
              topicId: topic.id,
              contentId: content.id,
              showContainer: true,
            },
          });
      }
    },
    getType(type) {
      //video, assignment, test, exam

      if (type == "video") return "Хичээл";
      else if (type == "assignment") return "Даалгавар";
      else if (type == "test") return "Сорил";
      else if (type == "exam") return "Шалгалт";
      else if (type == "lecture") return "Хичээл";
      else if (type == "seminar") return "Семинар";
      // else if(type=="homework")
      //   return "Гэрийн даалгавар";
      else if (type == "coursework") return "Бие даалт";
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  props: {
    topics: {
      required: true,
    },
    lesson: {
      required: true,
    },
    types: {
      required: false,
    },
    schoolId: {
      required: true,
    },
    lessonId: {
      required: true,
    },
    _editTopic: {
      required: true,
    },
  },
  created() {},
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>

<style scoped>
.topicTitle {
  /* font-family: 'Google Sans',Roboto,Arial,sans-serif; */
  font-size: 1.2rem;
  /* font-weight: 400; */
  /* line-height: 2.5rem; */
  color: #1967d2 !important;
}
.topicItemTitle {
  /* letter-spacing: .01785714em; */
  /* font-family: 'Google Sans',Roboto,Arial,sans-serif; */
  font-size: 0.875rem;
  font-weight: 500;
  /* line-height: 1.25rem; */
  color: #3c4043;
}
.text-ecllipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
}
.mycard:hover {
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.302),
    0 2px 6px 2px rgba(60, 64, 67, 0.149);
  /* transform: scale(1.1); */
  cursor: pointer;
}
</style>